module.exports = __webpack_public_path__ + "img/payment-logos-dinersclub.30351c39.png";